var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useAccessToken } from '~/AccessToken';
import * as ImpersonateApi from '~/Api/Impersonate';
import { useApi } from '~/ApiHooks';
import { useErrorHandler } from '~/ErrorHandler';
import { useSearchParams } from '~/Router';
import { Placeholder } from '~/UI';
export var Login = function (_a) {
    var accessToken = _a.accessToken, onComplete = _a.onComplete;
    var searchParams = useSearchParams();
    var _b = useAccessToken(), setAccessToken = _b[2];
    var _c = useApi(), apiSwitchBack = _c[0], switchBackResult = _c[1];
    var _d = useApi(), apiImpersonate = _d[0], impersonateResult = _d[1];
    var onUserError = useErrorHandler().onUserError;
    var switchBack = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var switchBackResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiSwitchBack(new ImpersonateApi.SwitchBackRequest())];
                case 1:
                    switchBackResult = _a.sent();
                    if (switchBackResult.value !== null) {
                        setAccessToken(switchBackResult.value.accessToken);
                    }
                    else {
                        onComplete();
                    }
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var impersonate = React.useCallback(function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var impersonation;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, apiImpersonate(new ImpersonateApi.LoginRequest(userId))];
                case 1:
                    impersonation = _g.sent();
                    if (impersonation.value !== null) {
                        setAccessToken(impersonation.value.accessToken);
                        onComplete();
                    }
                    else if ((_b = (_a = impersonation.error) === null || _a === void 0 ? void 0 : _a.has(ImpersonateApi.LoginError.userNotFound)) !== null && _b !== void 0 ? _b : false) {
                        onUserError('Uživatel za kterého se přihlašujete neexistuje');
                    }
                    else if ((_d = (_c = impersonation.error) === null || _c === void 0 ? void 0 : _c.has(ImpersonateApi.LoginError.externalServiceNotAllowed)) !== null && _d !== void 0 ? _d : false) {
                        onUserError('Za tohoto uživatele se nelze přihlásit');
                    }
                    else if ((_f = (_e = impersonation.error) === null || _e === void 0 ? void 0 : _e.has(ImpersonateApi.LoginError.forbidden)) !== null && _f !== void 0 ? _f : false) {
                        onUserError('K přihlášení za tohoto uživatel nemáte dostatečná práva');
                    }
                    return [2 /*return*/];
            }
        });
    }); }, []);
    React.useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var userId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = searchParams.get('targetUserId');
                        if (userId === null) {
                            return [2 /*return*/];
                        }
                        if (!(accessToken.impersonatedBy !== null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, switchBack()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        impersonate(userId);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [searchParams]);
    return switchBackResult.isLoading || impersonateResult.isLoading ? <Placeholder /> : <></>;
};
